import type {Storyblok} from 'storyblok-js-client';
import {registerStoryblokBridge, storyblokInit} from '@storyblok/js';
import {getStoryblokClient} from '@/storyblok/api/client';

declare module '#app' {
	interface NuxtApp {
		$storyblokApi: Storyblok
	}
}
declare module 'vue' {
	interface ComponentCustomProperties {
		$storyblokApi: Storyblok
	}
}

export default defineNuxtPlugin(() => {
	// https://github.com/storyblok/storyblok-js#getting-started
	// Loads Storyblok Bridge for real-time visual updates.
	// Provides a storyblokEditable function to link editable components to the Storyblok Visual Editor.
	storyblokInit();

	if (import.meta.client) {
		const storyId = Number(new URL(window.location.href).searchParams.get('_storyblok'));
		if (storyId) {
			// Reloads the preview after Save or Publish of this story in the Visual Editor.
			// Live `input` updates are not applied, the page renders the saved draft from the API.
			registerStoryblokBridge(storyId, () => {});
		}
	}

	// Create a Storyblok client instance separately, because we are connecting to our proxy without an access token
	return {provide: {storyblokApi: getStoryblokClient()}};
});
